import { createApi } from '@reduxjs/toolkit/query/react'

import { HYDRATE } from 'next-redux-wrapper'

import { apiPrivate } from '~/redux/utils/hom-api'

import { HOM_API_TAGS } from '~/redux/constants/tags.const'

export const homApi = createApi({
  reducerPath: 'homApi',
  baseQuery: apiPrivate,
  tagTypes: HOM_API_TAGS,
  endpoints: () => ({}),
  keepUnusedDataFor: 1,
  refetchOnMountOrArgChange: 5,
  extractRehydrationInfo(action, { reducerPath }) {
    if (action.type === HYDRATE) {
      return action.payload[reducerPath]
    }
  },
})
